<template>
  <div>
    <div class="row">
      <div class="col-md-5 border-right pr-md-4">
        <custom-drop-down
          v-model="current"
          :disabled="readOnly"
          fieldkey="id"
          fieldname="name"
          label="Secciones"
          :options="availableSections"
          placeholder="Seleccione"
        />

        <div class="mt-3">
          <action-button
            :disabled="readOnly"
            i="fas fa-file-plus"
            text="Añadir"
            variant="success"
            @click="add"
          />
        </div>
      </div>

      <div class="col-md-7 pl-md-4 mt-3 mt-md-0">
        <custom-chips-group
          :disabled="readOnly"
          no-background
          :no-wrap="true"
          object-text="name"
          :on-item-deleted="remove"
          :selected-items="model"
          title="Secciones Seleccionadas:"
        />
        <error
          v-if="showError && model.length < min"
          message="Debe añadir al menos una sección."
          variant="no-border"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomChipsGroup from 'CustomChipsGroup';
import Error from 'custom-error';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

export default {
  name: 'SpecialEvaluatorSections',
  components: { CustomDropDown, ActionButton, CustomChipsGroup, Error },
  mixins: [alertMixin],
  props: {
    sections: { type: Array, default: () => [] },
    value: { type: Array, default: () => [] },
    readOnly: { type: Boolean, default: false },
    min: { type: Number, default: 1 },
  },
  data() {
    return {
      current: null,
      showError: false,
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
    availableSections() {
      return this.sections.filter(
        (s) => !this.model.some((m) => m.sectionId === s.id)
      );
    },
  },
  watch: {
    sections: {
      immediate: true,
      handler(newList) {
        const validIds = newList.map((s) => s.id);
        const filtered = this.model.filter((m) =>
          validIds.includes(m.sectionId)
        );

        if (filtered.length !== this.model.length) {
          this.model = filtered;
        }
      },
    },
  },
  methods: {
    add() {
      if (!this.current) {
        this.ShowToast(
          '',
          'Para añadir, primero seleccione una sección.',
          'error'
        );
        return;
      }
      const payload = {
        sectionId: this.current.id,
        name: this.current.name,
      };
      this.model = [...this.model, { ...payload }];
      this.current = null;
      this.showError = false;
    },
    remove({ sectionId }) {
      this.model = this.model.filter((x) => x.sectionId !== sectionId);
    },

    async validate() {
      const valid = Array.isArray(this.model) && this.model.length >= this.min;
      this.showError = !valid;
      return valid;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .chips-container p.bold {
  font-weight: 100 !important;
  color: #6c757d !important;
}
</style>
